module.exports = __webpack_public_path__ + "img/Salud Contigo + Cuidados.43bef338.svg";